import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ConfirmationIconImage } from './confirmation-icon.svg';
import SvgIconWrapper from '../../../components/icons/SvgIconWrapper';

const ConfirmationIcon = ({ svgWrapperClassName, sx }) => (
  <SvgIconWrapper
    Icon={ConfirmationIconImage}
    svgWrapperClassName={svgWrapperClassName}
    sx={sx}
  />
);

ConfirmationIcon.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  svgWrapperClassName: PropTypes.string,
};

ConfirmationIcon.defaultProps = {
  sx: undefined,
  svgWrapperClassName: undefined,
};

export default ConfirmationIcon;
